/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Card, Row, Col, Typography, Breadcrumb } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { HubCPOverviewService } from "../../../../services/api/hubCPOverviewService";

const { Title } = Typography;

const OutscanPendingInscanToHubClickableReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { hubId, fromDate, toDate, bookingDateFrom, bookingDateTo } = location.state || {};

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const columns = [
        {
            title: "Sr no",
            dataIndex: "srNo",
            key: "srNo",
            render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: 80,
        },
        {
            title: "Tracking no",
            dataIndex: "trackingNo",
            key: "trackingNo",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Trip ID",
            dataIndex: "tripId",
            key: "tripId",
            width: 150,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const recordToStore = {
                                ...record,
                                vehicle_lcr_id: text,
                            };
                            sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                            window.open(window.location.origin + "/lcr-report", "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Stop ID",
            dataIndex: "stopId",
            key: "stopId",
            width: 150,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const recordToStore = {
                                ...record,
                                vehicle_lcr_id: text,
                            };
                            sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                            window.open(window.location.origin + "/lcr-report", "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Trip Departed At",
            dataIndex: "tripDepartedAt",
            key: "tripDepartedAt",
            width: 180,
        },
        {
            title: "Trip Received At",
            dataIndex: "tripReceivedAt",
            key: "tripReceivedAt",
            width: 180,
        },
        {
            title: "To Hub",
            dataIndex: "toHub",
            key: "toHub",
            width: 180,
        },
        {
            title: "Mode",
            dataIndex: "mode",
            key: "mode",
            width: 120,
        },
    ];

    const abortControllerRef = useRef(null);

    const fetchData = async (pageNum = 1, pageSize = 10) => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        const { signal } = abortControllerRef.current;

        setLoading(true);
        try {
            const params = {
                tripStartHubId: hubId,
                page: pageNum - 1, // API uses 0-based indexing
                size: pageSize,
                fromDate,
                toDate,
                bookingDateFrom,
                bookingDateTo,
            };
            const response = await HubCPOverviewService.getOutscanPendingInscanToHubClickable(params, { signal });

            if (response && response.data) {
                setData(response.data);
                setPagination(prev => ({
                    ...prev,
                    current: pageNum,
                    pageSize: pageSize,
                    total: response.count || 0
                }));
            } else {
                setData([]);
            }
        } catch (error) {
            if (error.name === "CanceledError") {
                console.log("Request canceled");
                return;
            }
            console.error("Error fetching data:", error);
            setData([]);
        } finally {
            if (!signal.aborted) {
                setLoading(false);
            }
        }
    };

    const handleDownload = async () => {
        try {
            const params = {
                tripStartHubId: hubId,
                fromDate,
                toDate,
                bookingDateFrom,
                bookingDateTo,
            };
            const url = await HubCPOverviewService.getOutscanPendingInscanToHubClickableDownload(params);
            if (url) {
                window.open(url, "_blank");
            }
        } catch (error) {
            console.error("Error downloading report:", error);
        }
    };

    useEffect(() => {
        // Only fetch if hubId is available or if implicit context allows
        fetchData(pagination.current, pagination.pageSize);

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
        // eslint-disable-next-line reactive-hooks/exhaustive-deps
    }, [hubId, fromDate, toDate, bookingDateFrom, bookingDateTo]);

    const handleTableChange = (newPagination) => {
        fetchData(newPagination.current, newPagination.pageSize);
    };

    return (
        <div className="hub-manager-shipment-details" style={{ padding: "20px" }}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
                    <HomeOutlined /> Dashboard
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    Hub Manager Overview
                </Breadcrumb.Item>
                <Breadcrumb.Item>Outscan Pending Inscan To Hub</Breadcrumb.Item>
            </Breadcrumb>

            <Card style={{ marginTop: "16px" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                onClick={() => navigate(-1)}
                                style={{ marginRight: "16px", border: "none", background: "transparent" }}
                            />
                            Outscan Pending Inscan To Hub
                        </Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={handleTableChange}
                    rowKey="trackingNo"
                    scroll={{ x: 1200 }}
                />
            </Card>
        </div>
    );
};

export default OutscanPendingInscanToHubClickableReport;
